<template>
	<SimpleModalComponent
		heading="Delete asset"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<p>
				Are you sure you want to delete this asset? This action is <strong>irreversible</strong> and will also delete all stages uploaded to this asset.
			</p>

			<p
				v-if="error_message"
				class="error-message"
			>
				{{ error_message }}
			</p>
		</template>

		<template #buttons>
			<button
				class="button"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill-danger"
				:class="{ 'button--loading': loading }"
				@click="deleteTheAsset"
			>
				Delete
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { ref, defineEmits, defineProps } from 'vue';
import { useDataStore } from '../../stores/data';

const emit = defineEmits( [ 'asset-deleted', 'close-modal' ] );

const props = defineProps( {
	asset: {
		required: true,
		type: Object
	}
} );

const { deleteAsset } = useDataStore();

const loading = ref( false );
const error_message = ref( null );

const deleteTheAsset = async() => { // eslint-disable-line snakecasejs/snakecasejs
	error_message.value = null;
	loading.value = true;

	try {
		const response = await deleteAsset( { asset_id: parseInt( props.asset.id ) } );
		if ( response && response.data ) {
			emit( 'asset-deleted' );
		}
	} catch ( error ) {
		error_message.value = error;
		loading.value = false;
	}
};
</script>